import { filterBarGrey, filterBarRed, primaryColor } from '../../../theme';
import { FilterBarOptions } from './types';

export const defaultOptions: FilterBarOptions = {
  allowDelete: true,
  justifyContent: 'flex-start',
  filterPillColors: {
    default: primaryColor,
    stale: filterBarGrey,
    notEqual: filterBarRed,
  },
};
